define('Responsive/util/extend',['require','exports','module','./array'],function(require,exports,module){
	var slice=require('./array').slice;

	var helper = function(o1,o2){
		var key;

        for(key in o2){
            if(o2.hasOwnProperty(key)){
                o1[key]=o2[key];
            }
        }        
        return o1 || {};
    };
    return function (){
        var i=0,
        	objs = slice(arguments),
        	tar = objs.shift() || {},
        	len=objs.length;

        if(len){
	        for(; i<len; i++){
	        	helper(tar,objs[i]);
	       	}
        }
        return tar;
    };
});

